import React, { Component } from 'react';
import { TabView } from 'primereact/components/tabview/TabView';
import { styles } from './ModalTabView.styles';

class ModalTabView extends Component {
  render() {
    return <TabView style={styles.modaltabview}>{this.props.children}</TabView>;
  }
}

export default ModalTabView;



// WEBPACK FOOTER //
// ./src/components/common/modaltabview/ModalTabView.js